import React, { useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import AppLayout from '../../../layouts/AppLayout/AppLayout';
import { NioSection, NioButton } from '../../../components';
import { useTranslation } from '../../../i18n/I18nProvider';

function RequestProjectTitle() {
  const navigate = useNavigate();
  const location = useLocation();
  const { serviceId } = useParams();
  const { t } = useTranslation();
  const [projectTitle, setProjectTitle] = useState(location.state?.projectTitle || '');

  const selectedSubService = location.state?.selectedSubService || t('common.subService');
  const parentServiceTitle = location.state?.parentServiceTitle || t('common.service');

  return (
    <AppLayout title={t('wizard.step2Title')} rootClass="layout-1">
      <style>{`
        .request-title-page {
          background: #f2f3f5;
          min-height: 78vh;
          border-radius: 14px;
          position: relative;
          display: flex;
          flex-direction: column;
        }
        .request-title-content {
          flex: 1 1 auto;
          width: 100%;
          max-width: 620px;
          margin: 0 auto;
          padding-top: 5.5rem;
          padding-bottom: 2rem;
        }
        .request-title-step {
          color: #697586;
          font-size: 0.9rem;
          margin-bottom: 0.25rem;
        }
        .request-title-heading {
          color: #0f2b3d;
          font-weight: 700;
          margin-bottom: 2rem;
        }
        .request-title-label {
          color: #3e4a58;
          font-weight: 500;
          margin-bottom: 0.5rem;
          display: inline-block;
        }
        .request-title-input {
          width: 100%;
          border: 1px solid #d6dde5;
          border-radius: 6px;
          height: 42px;
          padding: 0 0.8rem;
          color: #0f2b3d;
          background: #fff;
        }
        .request-title-counter {
          text-align: right;
          color: #a1acb8;
          font-size: 0.75rem;
          margin-top: 0.35rem;
        }
        .request-title-footer {
          flex-shrink: 0;
          margin-top: auto;
          border-top: 1px solid #dde3ea;
          padding: 0.7rem 1.1rem;
          display: flex;
          justify-content: space-between;
          align-items: center;
          background: #f8f9fb;
          border-bottom-left-radius: 14px;
          border-bottom-right-radius: 14px;
          z-index: 5;
          box-shadow: 0 -4px 16px rgba(15, 43, 61, 0.08);
        }
      `}</style>

      <NioSection className="pt-120 pt-lg-160 pb-4">
        <NioSection.Content>
          <div className="request-title-page p-3 p-md-4">
            <div className="request-title-content">
              <div className="request-title-step">{t('wizard.step', { n: 2 })}</div>
              <h2 className="request-title-heading">{t('wizard.step2Heading')}</h2>
              <div>
                <label className="request-title-label" htmlFor="projectTitle">
                  <strong>{t('wizard.step2Label')}</strong>
                </label>
                <input
                  id="projectTitle"
                  className="request-title-input"
                  maxLength={120}
                  value={projectTitle}
                  onChange={(e) => setProjectTitle(e.target.value)}
                />
                <div className="request-title-counter">{projectTitle.length}/120</div>
              </div>
            </div>

            <div className="request-title-footer">
              <NioButton className="btn btn-primary" label={t('common.back')} onClick={() => navigate(-1)} />
              <NioButton
                className="btn btn-primary"
                label={t('common.next')}
                onClick={() =>
                  navigate(`/service/${serviceId}/request-demand-details`, {
                    state: {
                      selectedSubService,
                      parentServiceTitle,
                      projectTitle: projectTitle.trim(),
                    },
                  })
                }
              />
            </div>
          </div>
        </NioSection.Content>
      </NioSection>
    </AppLayout>
  );
}

export default RequestProjectTitle;
